export interface EmptyCallCandidate {
	duration?: unknown;
	durationSeconds?: unknown;
	transcript?: unknown;
	formattedTranscript?: unknown;
}

function parseDisplayedDurationSeconds(duration: unknown): number | null {
	if (typeof duration === "number") {
		return Number.isFinite(duration) && duration >= 0 ? duration : null;
	}

	if (typeof duration !== "string") return null;

	const normalized = duration.trim().toLowerCase();
	if (!normalized) return null;

	if (normalized.endsWith("s")) {
		const seconds = Number(normalized.slice(0, -1));
		return Number.isFinite(seconds) && seconds >= 0 ? seconds : null;
	}

	const parts = normalized.split(":");
	if (
		(parts.length === 2 || parts.length === 3) &&
		parts.every((part) => part !== "" && Number.isFinite(Number(part)))
	) {
		const seconds = parts.reduce((total, part) => total * 60 + Number(part), 0);
		return seconds >= 0 ? seconds : null;
	}

	const seconds = Number(normalized);
	return Number.isFinite(seconds) && seconds >= 0 ? seconds : null;
}

function hasTranscript(value: unknown): boolean {
	if (typeof value === "string") return value.trim().length > 0;
	return value !== null && value !== undefined;
}

/** An empty call lasts at most two seconds and has no transcript content. */
export function isEmptyCall(call: EmptyCallCandidate): boolean {
	const preferredDuration =
		typeof call.durationSeconds === "number" &&
		Number.isFinite(call.durationSeconds) &&
		call.durationSeconds >= 0
			? call.durationSeconds
			: null;
	const durationSeconds =
		preferredDuration ?? parseDisplayedDurationSeconds(call.duration);
	const transcriptPresent =
		hasTranscript(call.formattedTranscript) || hasTranscript(call.transcript);

	return durationSeconds !== null && durationSeconds <= 2 && !transcriptPresent;
}
